(function () {
    'use strict';

    const shared = {
        ID: "FE-4045-downtime-modal"
    };

    const { ID } = shared;

    let titleText = "Planned downtime notification";
    let paragraphText = "The HPE Store will be <b>unavailable from 02:30 to 04:30 GTM on Aug 11</b> while we perform scheduled maintenance."

    const setup = () => {
        document.documentElement.classList.add(ID);
        titleText = window.FEi18n.ask(titleText);
        paragraphText = window.FEi18n.ask(paragraphText);
    };

    const closeIcon = `<svg width="20px" height="20px" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 21.32L21 3.32001" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M3 3.32001L21 21.32" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`;

    const modal = () => {
        const html = `
            <div class="${ID}__modal ${ID}__open">
                <div class="${ID}__modal-overlay"></div>
                <div class="${ID}__modal-container">
                    <div class="${ID}__modalWrapper">
                        <div class="${ID}__modal-info">
                            <h2 class="${ID}__modal-title">${titleText}</h2>
                            <span class="${ID}__modal-closeWrapper">${closeIcon}</span>
                        </div>
                        <p class="${ID}__modal-subtitle">${paragraphText}</p>
                    </div>
                </div>
            </div>
        `;
        return html;
    };

    const init = () => {
        const attachPoint = document.body;

        if (window.localStorage.getItem("hasSeenDowntimeModal") === null) {
            attachPoint.insertAdjacentHTML('beforeend', modal());
        };
    };

    const activate = () => {
        setup();

        document.body.addEventListener('click', (e) => {
            const { target } = e;
            if (target.closest(`.${ID}__modal-closeWrapper`) || target.closest(`.${ID}__modal-overlay`)) {
                const modal = document.querySelector(`.${ID}__modal`);
                if (modal) {
                    modal.remove();
                    window.localStorage.setItem("hasSeenDowntimeModal", true);
                }
            }
        });

        init();
    };

    window.feUtils.waitForConditions({
        conditions: ['body'],
        activity: feProjectId,
        callback: activate
    });
})();
